import {
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, map } from 'rxjs';

import { getOffsetDate } from '@services/utils';

import { RequestNameAndFile, requestNamesAndDemoFiles } from './debug.interceptor';

@Injectable()
export class DemoInterceptor implements HttpInterceptor {
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Let the request pass through if it's not a demo request,
    // if it is a request to the assets/api or if it is a request to the users api
    if (
      !this.router.url.toLowerCase().includes('demo=true') ||
      req.urlWithParams.toLowerCase().includes('./assets/api') ||
      req.urlWithParams.toLowerCase().includes('/api/users')
      //   req.urlWithParams.toLowerCase().includes('/api/calloffs/createcalloff')
    ) {
      return next.handle(req);
    }

    // Map request to files
    const requestName = requestNamesAndDemoFiles.find((name: RequestNameAndFile) =>
      req.urlWithParams.includes(name.key),
    ) || {
      key: 'fallback',
      file: `fallback.json?${req.urlWithParams}`,
      type: 'Fallback',
    };

    if (requestName.key === 'fallback') {
      console.log(req.urlWithParams);
    }

    // Retern a new HttpResponse with the data from the file
    return this.http.get(`./assets/api/${requestName.file}`).pipe(
      map((data) => {
        let body = data;

        // adjust dates to be relative to now to keep mock data looking fresh in the app
        const relativeToThisDate = new Date();
        const mockPivotDate = new Date(getOffsetDate(20));
        const diffInMs = relativeToThisDate.valueOf() - mockPivotDate.valueOf();

        if (
          // Update dates for data-arrays
          requestName.type === 'ActiveOrders' ||
          requestName.type === 'Calloff' ||
          requestName.type === 'Claims' ||
          requestName.type === 'Invoices'
        ) {
          body = (data as any[])?.map((dataItem: any) => {
            return this.getDataWithModifiedDates(requestName, dataItem, diffInMs);
          });
        } else if (
          // Update dates for data objects
          requestName.type === 'DefaultValues' ||
          requestName.type === 'Inquiry' ||
          requestName.type === 'Order' ||
          requestName.type === 'QualityReport' ||
          requestName.type === 'Deliveries'
        ) {
          body = this.getDataWithModifiedDates(requestName, data, diffInMs);
        }

        return new HttpResponse({ status: 200, body });
      }),
    );
  }

  private getDataWithModifiedDates(requestName: RequestNameAndFile, d: any, diffInMs: number) {
    requestName.datesToModify?.forEach((dateKey) => {
      if (dateKey.indexOf('.') > -1) {
        // nested object keys.
        const nestedKeys = dateKey.split('.');
        if (nestedKeys.length == 2 && d[nestedKeys[0]][nestedKeys[1]]) {
          d[nestedKeys[0]][nestedKeys[1]] = this.addMillisecondsToDate(
            d[nestedKeys[0]][nestedKeys[1]],
            diffInMs,
          );
        }
      } else if (d[dateKey]) {
        d[dateKey] = this.addMillisecondsToDate(d[dateKey], diffInMs);
      }
    });

    return d;
  }

  private addMillisecondsToDate(
    dateStringToAdjust: string | null | undefined,
    milliseconds: number,
  ): string | null | undefined {
    if (!dateStringToAdjust) {
      return dateStringToAdjust;
    }
    const date = new Date(dateStringToAdjust);
    return new Date(date.valueOf() + milliseconds).toISOString();
  }
}
